/* "Kies je land" picker — live stock refresh.
   The strikes are server-rendered; this re-checks each country's real
   availability via /products/<handle>.js on load (same endpoints the
   bundle widget fetches, so the browser cache makes this ~free) and
   updates the sold-out state in case the page came from cache. */
(function () {
  var init = function () {
    var pickers = document.querySelectorAll('[data-wk-country-picker]');
    if (!pickers.length) return;
    var routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
    var root = routes.root && routes.root !== '/' ? routes.root.replace(/\/+$/, '') : '';
    pickers.forEach(function (el) {
      el.querySelectorAll('[data-handle]').forEach(function (flag) {
        fetch(root + '/products/' + flag.dataset.handle + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (d) {
            if (!d || !d.variants) return;
            var available = d.variants.some(function (v) {
              return v.available;
            });
            flag.classList.toggle('is-soldout', !available);
          })
          .catch(function () {});
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
